import { render, staticRenderFns } from "./ToastList.vue?vue&type=template&id=f24fe454&"
import script from "./ToastList.vue?vue&type=script&lang=js&"
export * from "./ToastList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports